import { atom } from "recoil";

const bookmarkState = atom<Record<string, any>>({
    key: "bookmarkState",
    default: [],
});

export default bookmarkState;
